import { render, staticRenderFns } from "./bluetooth.vue?vue&type=template&id=63fc4944&scoped=true"
import script from "./bluetooth.vue?vue&type=script&lang=js"
export * from "./bluetooth.vue?vue&type=script&lang=js"
import style0 from "./bluetooth.vue?vue&type=style&index=0&id=63fc4944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc4944",
  null
  
)

export default component.exports